<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row d-print-none">
          <div class="col-12">
              <div class="card">
                  <div class="card-body">
                      <h4 class="card-title">Detaylı Arama</h4>
                      <form class="repeater" @submit.prevent="get">
                          <div data-repeater-list="group-a">
                              <div class="row">
                                  <div class="form-group col-sm-2">
                                      <label>Player (OYUNCU) ID</label>
                                      <label>
                                          <b-input
                                                  type="text"
                                                  v-model="player_id"
                                                  class="form-control"
                                          />
                                      </label>
                                  </div>
                                  <div class="form-group col-sm-2">
                                      <label>Yatırım ID</label>
                                      <label>
                                          <b-input
                                                  type="text"
                                                  v-model="id"
                                                  class="form-control"
                                          />
                                      </label>
                                  </div>
                                  <div class="col-sm-2">
                                      <b-form-group
                                              label="Başlangıç Tarihi"
                                              label-for="input-1"
                                      >
                                          <b-form-datepicker  v-model="startDate" class="mb-2"></b-form-datepicker>
                                      </b-form-group>
                                  </div>
                                  <div class="col-sm-2">
                                      <b-form-group
                                              label="Bitiş Tarihi"
                                              label-for="input-1"
                                      >
                                          <b-form-datepicker  v-model="endDate" class="mb-2"></b-form-datepicker>
                                      </b-form-group>
                                  </div>
                                  <div class="form-group col-sm-2">
                                      <label>Gönderen</label>
                                      <input
                                              type="text"
                                              v-model="name"
                                              class="form-control"
                                      />
                                  </div>
                                  <div class="form-group col-sm-2">
                                      <label>Yatırımı Alan</label>
                                      <b-input
                                              type="text"
                                              v-model="account_name"
                                              class="form-control"
                                      />
                                  </div>
                                  <div class="form-group col-sm-2">
                                      <label>IBAN</label>
                                      <input
                                              type="text"
                                              v-model="account_number"
                                              class="form-control"
                                      />
                                  </div>
                                  <div class="form-group col-sm-2">
                                      <label>API TRX</label>
                                      <input
                                              type="text"
                                              v-model="api_trx"
                                              class="form-control"
                                      />
                                  </div>
                                  <div class="form-group col-sm-2">
                                      <label>İşlem Yapan Kull.</label>
                                      <v-select :options="admins" v-model="admin_id "></v-select>
                                  </div>
                                  <div class="form-group col-sm-4">
                                      <label>Banka Hesabı</label>
                                      <v-select :options="bank_accounts" v-model="bank_account_id" multiple></v-select>
                                  </div>
                                  <div class="col-lg-2 align-self-center">
                                      <b-button-group>
                                          <b-button variant="info" type="submit" class="btn-sm"> <i class="fa fa-search" /> Ara</b-button>
                                          <b-button variant="danger" @click="clearSearchForm" class="btn-sm"> <i class="fa fa-trash" /> Sıfırla</b-button>

                                      </b-button-group>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
    <div class="row">
      <div class="col-lg-12">
        <b-alert variant="info" show="" v-if="!startDate || !endDate"> Bugüne ait ödemeler listelenmektedir.</b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 flex flex-row flex-wrap items-center gray7 f2">
          <h4>
            <div>
              <b-badge variant="success" class="sites-buttons mr-2" v-for="(item, index) in activatedSites" :key="index" >
                <div @click="removeActivatedSite({id: item.id})">
                  {{ item.site_name }} <i class="fas fa-times-circle"></i>
                </div>
              </b-badge>
            </div>
            <div>
              <b-badge class="sites-buttons mr-2" v-for="(item, indexd) in sites" :key="indexd" >
                <div @click="addActivatedSite({id: item.id})">
                  {{ item.site_name }} <i class="fas fa-plus-circle"></i>
                </div>
              </b-badge>
            </div>
          </h4>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-lg-12">
        <b-button-group>
          <b-button :class="{'active' : tabStatus === ''}" @click="tabStatus = ''"  v-b-tooltip:v-b-hover title="Tüm İşlemler">
            <i class="fas fa-list"></i> Tüm İşlemler
          </b-button>
          <b-button  :class="{'active' : tabStatus === 'approved'}" @click="tabStatus = 'approved'"  v-b-tooltip:v-b-hover title="Onaylanmış işlemler">
            <i class="fas fa-check-circle text-success"></i>&nbsp;<code v-if="approvedTotal > 0">[{{ approvedTotal }}]</code> Onaylanmış Talepler
          </b-button>
            <b-button :class="{'active' : tabStatus === 'waiting_site'}" @click="tabStatus = 'waiting_site'"  v-b-tooltip:v-b-hover title="Manuel onay bekleyen talepler">
                <i class="fas fa-hourglass-half text-warning"></i>&nbsp;<code v-if="manualTotal > 0">[{{ manualTotal }}]</code>  Onay Bekleyen Talepler
            </b-button>
            <b-button :class="{'active' : tabStatus === 'get_bank'}" @click="tabStatus = 'get_bank'"  v-b-tooltip:v-b-hover title="Hesap No. Alanlar">
                <i class="fas fa-university text-primary"></i>&nbsp; <code v-if="getAccountTotal > 0">[{{ getAccountTotal }}]</code> Hesap Talep Edenler
            </b-button>
          <b-button :class="{'active' : tabStatus === 'canceled'}" @click="tabStatus = 'canceled'" v-b-tooltip:v-b-hover title="Red edilmiş İşlemler">
            <i class="fas fa-minus-circle text-danger"></i>&nbsp; Red Edilmiş Talepler
          </b-button>
          <b-button :class="{'active' : tabStatus === 'edited'}" @click="tabStatus = 'edited'" v-b-tooltip:v-b-hover title="Düzenlenmiş İşlemler">
            <i class="fas fa-edit text-warning"></i>&nbsp; Düzenlenmiş Talepler
          </b-button>
        </b-button-group>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <div class=" float-right">
        </div>
        <div class="card">
          <div class="card-body">
            <h5 class="card-header d-flex justify-content-between align-items-center d-print-none">
              İşlemler
                <b-button-group>
                    <download-excel
                            :data="tableData"
                            :fields="excelFields"
                            type="xls"
                            v-if="!loading"
                            :before-generate = "excel"
                    >
                        <b-button variant="success" show v-if="!loading" class="btn btn-sm"> <i class="fa fa-file-excel"></i> Excel </b-button>
                    </download-excel>
                </b-button-group>
            </h5>
            <div class="table-responsive mb-0" >
              <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :busy="loading"
                  show-empty
                  striped
              >
                <template v-slot:table-busy>
                  <div class="text-center text-white my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Yükleniyor..</strong>
                  </div>
                </template>
                <template v-slot:empty="">
                  <b-alert show variant="warning">
                    Kayıt bulunamadı.
                  </b-alert>
                </template>
                <template v-slot:cell(id)="data">
                  <b-badge variant="info" v-if="data.item.mail" v-b-tooltip:v-b-hover title="Bu talep mail sistemi ile otomatik yanıtlandı.">
                    <i class="fas fa-mail-bulk" />
                  </b-badge>
                  {{data.item.id}}
                </template>
                <template v-slot:cell(amount)="data">
                  <div v-if="parseFloat(data.item.amount_user) != parseFloat(data.item.amount)">
                    <del>
                      {{data.item.amount_user | currency}} TL
                    </del>
                  </div>
                  {{data.item.amount | currency}} TL
                </template>
                <template v-slot:cell(site_id)="data">
                  <div v-if="data.item.site_detail">
                    {{data.item.site_detail.site_name}}
                  </div>
                </template>
                  <template v-slot:cell(player_id)="data">
                      <b-badge @click="$store.dispatch('getCopy', {text: data.item.player_id, state: true})">
                          {{ data.item.player_id }} <i class="fas fa-copy"></i>
                      </b-badge>
                  </template>
                  <template v-slot:cell(account_name)="data">
                      <div v-if="data.item.aninda_deposit">
                          <b-badge variant="success">
                              <i class="fas fa-robot"></i> ANINDA OTO.
                          </b-badge>
                      </div>
                      <div v-else>
                          <b-badge @click="$store.dispatch('getCopy', {text: data.item.account_name, state: true})">
                              {{ data.item.account_name }} <i class="fas fa-copy"></i>
                          </b-badge>
                          <br>
                          <b-badge @click="$store.dispatch('getCopy', {text: data.item.account_number, state: true})">
                              {{ data.item.account_number }} <i class="fas fa-copy"></i>
                          </b-badge>
                      </div>
                  </template>
                <template v-slot:cell(name)="data">
                    <b-badge @click="$store.dispatch('getCopy', {text: data.item.name, state: true})">
                        {{ data.item.name }}
                    </b-badge>
                    <br>
                    <b-badge variant="success" @click="$store.dispatch('getCopy', {text: data.item.name, state: true})">
                        {{ data.item.deposit_bank }}
                    </b-badge>
                </template>
                <template v-slot:cell(tc)="data">
                  <div @click="$store.dispatch('getCopy', {text: data.item.tc, state: true})">
                    {{ data.item.tc }}
                  </div>
                </template>
                <template v-slot:cell(status)="data">
                  <b-badge variant="success" v-if="data.item.status === '1'"> Onaylandı </b-badge>
                  <div v-if="data.item.status === '2'">
                    <b-badge variant="danger"> RED </b-badge>
                    <br>
                    <b-badge  @click="$store.dispatch('getCopy', {text: data.item.answer, state: true})"> <code>{{ data.item.answer }}</code> </b-badge>
                  </div>
                  <div v-if="data.item.status === '0'">
                    <b-badge v-if="data.item.sended">
                      <code class="text-warning"> Yönetim Onay bekleniyor </code>
                      <br>
                      <code class="text-success">
                        <i class="fas fa-check" /> Kullanıcı Butona Tıkladı.
                      </code>
                    </b-badge>
                    <b-badge v-else variant="primary"> <i class="fas fa-spin fa-spinner"></i> Yatırım Yapması Bekleniyor. [Buton]</b-badge>
                  </div>
                    <br v-if="data.item.api_status === true || data.item.api_status === false">
                    <b-badge>TRX: <code class="text-success">{{ data.item.api_trx }} <i class="fa fa-copy" @click="$store.dispatch('getCopy', {text: data.item.api_trx, state: true})"></i></code> </b-badge>

                </template>
                <template v-slot:cell(api_service)="data">
                  <div v-if="data.item.api_service">
                    <b-badge variant="success" v-if="data.item.api_status === true" @click="apiMessage(data.item.id)"> API Onayladı. <i class="fas fa-edit" /> </b-badge>
                    <b-badge variant="danger" v-if="data.item.api_status === false" @click="apiMessage(data.item.id)"> API RED.  <i class="fas fa-edit" /> </b-badge>
                  </div>
                  <div v-else>
                    <b-badge>Manuel Sistem</b-badge>
                  </div>
                </template>
                <template v-slot:cell(date)="data">
                  {{data.item.date | formatDate}}
                </template>
                <template v-slot:cell(details)="data">
                  <b-button-group>
                    <div v-if="!data.item.user_wait && data.item.status != '1' && data.item.site_detail" >
                      <b-button v-if="data.item.site_detail.api" class="btn-sm" variant="success" v-b-tooltip:v-b-hover title="Yatırımı Onayla" @click="approveDepositApi({id: data.item.id})"> <i class="fas fa-check-circle"></i>  </b-button>
                      <b-button v-else class="btn-sm" variant="success" v-b-tooltip:v-b-hover title="Yatırımı Onayla" @click="approveDeposit({id: data.item.id})"> <i class="fas fa-check-circle"></i>  </b-button>
                    </div>
                    <b-button v-if="data.item.status != '2'" class="btn-sm" variant="danger" v-b-tooltip:v-b-hover title="Yatırımı İptal Et" @click="cancelDeposit({id: data.item.id  })"> <i class="fas fa-minus-circle"></i></b-button>
                    <b-button v-if="data.item.mail" class="btn-sm" v-b-tooltip:v-b-hover title="Yatırıma ait maili oku" @click="readMail(data.item.email_id)"> <i class="fas fa-envelope-open-text"></i>  </b-button>
                  </b-button-group>
                </template>
                <template v-slot:cell(user_id)="data">
                  <div v-if="data.item.user_id > 0">
                    {{ data.item.editor_detail.username }} <br>
                    <b-badge>{{data.item.update_date | formatDate}}</b-badge>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row d-print-none">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <read-mail :id="readId"></read-mail>
    <ApiMessage :item="apiResponse"></ApiMessage>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ReadMail from "@/components/modals/bank-accounts/ReadMail";
import ApiMessage from "@/components/modals/deposits/ApiMessage";
import bankAccountsService from "@/services/bankAccountsService";
import depositService from "@/services/depositService";

export default {
  page: {
    title: "Anasayfa",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ReadMail, ApiMessage },
  data() {
    return {
      apiResponse: {notification_url: '', message: ''},
      readId: 0,
      title: "Anasayfa",
      items: [
        {
          text: "Anasayfa",
          to: "/"
        },

      ],
      name : '',
      fields: [
          {key: 'site_id', label: 'Site Adı', sortable: true },
          {key: 'bank_name', label: 'Banka Adı', sortable: true },
        {key: 'account_name', label: 'Hesap Bilgileri', sortable: true },
        {key: 'tc', label: 'Tc', sortable: true },
          {key: 'name', label: 'Gönderen', sortable: true },
          {key: 'player_id', label: 'PlayerID', sortable: true },
        {key: 'amount', label: 'Tutar', sortable: true },
        {key: 'status', label: 'Durum', sortable: false },
        {key: 'date', label: 'Tarih', sortable: false },
          {key: 'details', label: '#', sortable: false },
          {key: 'user_id', label: 'Düzenleyen', sortable: false },

      ],
      id: '',
      tableData: [],
      totalRows: 0,
      loading: true,
      perPage : 0,
      currentPage: 1,
      tabStatus : 'waiting_site',
      sites: [],
      startDate: '',
      endDate: '',
      answerMessages: [],
      api_trx: '',
      account_name: '',
      account_number: '',
      admins: [],
      admin_id: '',
      approvedTotal: 0,
      approvedAmount: 0,
      manualTotal: 0,
      getAccountTotal: 0,
      manualAmount: 0,
      mailTotal: 0,
      mailAmount: 0,
      activatedSites: [],
      siteStatistics: [],
      siteFields: [
        {key: 'site_name', label: 'Site', sortable: false },
        {key: 'approvedTotal', label: 'Yatırım Tutarı', sortable: false },
      ],
      payment_type: '',
      panel_two: false,
      panel_two_loading: true,
      paymentId: '',
      tc:'',
      tc_sorgu_response: null,
      bank_accounts: [],
        bank_account_id: '',
        player_id: '',
        excelFields: {}
    };
  },
  methods: {
    get() {
      this.getStatistics()
      this.loading = true
      let admin_id = ''
      if(this.admin_id)
        admin_id = this.admin_id.value

      depositService.deposits({player_id: this.player_id, bank_account_id: this.bank_account_id, panel_two: this.panel_two, payment_type: this.payment_type, status: this.tabStatus, admin_id: admin_id ,account_name: this.account_name, account_number: this.account_number,  name: this.name, site_id: this.activatedSites ,page: this.currentPage,  id: this.id, startDate: this.startDate, endDate: this.endDate, api_trx: this.api_trx})
          .then((res) => {
            this.loading = false
            if(res.state){
              this.tableData =  res.data
              this.page = res.page
              this.totalRows = res.rows
              this.perPage = res.perPage

            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    messages() {
      bankAccountsService.answers()
          .then((res) => {
            if(res.state)
              res.data.map((msg) => {
                this.answerMessages.push(msg.text)
              })
          })
    },
    panelTwoCheck() {
      this.panel_two_loading = true
      depositService.panelTwoCheck()
          .then((res) => {
            this.panel_two = res.is_on
            this.panel_two_loading = false
            this.messages()
            this.getSites()
            this.getAdmins()

          })
    },
    panelTwoEdit() {
      depositService.panelTwoEdit()
          .then(() => {
            this.panelTwoCheck()
          })
    },
    clearSearchForm() {
      this.payment_id = ''
      this.api_return_id = ''
      this.api_id = ''
      this.startDate = ''
      this.endDate = ''
      this.id = ''
    },
    readMail(id) {
      this.readId = id
      setTimeout(() => {
        this.$bvModal.show('readMailModal')
      }, 100)
    },
    apiMessage(item) {
      this.apiResponse = item
      setTimeout(() => {
        this.$bvModal.show('apiMessageModal')
      }, 100)
    },
    approveDeposit(item){
       const findIndex = this.tableData.findIndex(e => e.id === item.id)
      const name = this.tableData[findIndex].name
      const site_name = this.tableData[findIndex].site_detail
        const amount = this.tableData[findIndex].amount
        const history = this.tableData[findIndex].history
        let historyArea = ''
        if(history.length > 0){
            let historyList = ''
            history.map((item) => {
                let status = ''
                if(item.status === '1')
                    status = '<span class="badge badge-success">Onaylandı.</span>'
                else if(item.status === '2')
                    status = '<span class="badge badge-danger">Red Edildi.</span>'
                historyList = historyList +
                    '    <tr>\n' +
                    '      <th><span class="badge badge-secondary">'+item.bank_name+'</span></th>\n' +
                    '      <th><span class="badge badge-secondary">'+this.$options.filters.currency(item.amount)+' TRY</span></th>\n' +
                    '      <th><span class="badge badge-secondary">'+this.$options.filters.formatDate(item.date)+'</span></th>\n' +
                    '      <td>'+status+'</td>\n' +
                    '    </tr>\n'
            })
            historyArea = '<table class="table table-dark">\n' +
                '  <thead>\n' +
                '    <tr>\n' +
                '      <th scope="col">Banka</th>\n' +
                '      <th scope="col">Tutar</th>\n' +
                '      <th scope="col">Tarih</th>\n' +
                '      <th scope="col">Durum</th>\n' +
                '    </tr>\n' +
                '  </thead>\n' +
                '  <tbody>\n' +
                historyList+
                '  </tbody>\n' +
                '</table>\n'
        }
        else
            historyArea = 'Geçmiş yatırımı bulunamadı..'
      this.$swal({
        title: "Yatırım onaylanacaktır, emin misiniz?",
        html: "<label ><i class='fas fa-globe'></i> "+site_name.site_name+"</label>" +
            "<br> <label ><i class='fas fa-user'></i> "+name+"</label>" +
            "<br> <label ><i class='fas fa-money-bill'></i> "+amount+" TL</label><br> "+
          historyArea,
        icon: 'success',
        input: 'text',
        inputValue: amount,
        inputAttributes: {
          autocapitalize: 'off',
          placeholder: "Yatırım Tutarı",
        },
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: "Gönder",
        cancelButtonText: "Vazgeç"
      }).then((result) => {
        if(result.value){
          depositService.approveDeposit({id: item.id, amount: result.value})
              .then((res) => {
                if(res.state){
                  this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Kaydedildi.', message: ''})
                }else{
                  this.$store.dispatch('getConfirmMessage', {show:true, icon: 'error', title: 'Ops!', message: res.message})
                }
              })
        }
      })
    },
    approveDepositApi(item){
      const findIndex = this.tableData.findIndex(e => e.id === item.id)
      const name = this.tableData[findIndex].name
      const site_name = this.tableData[findIndex].site_detail
      const amount = this.tableData[findIndex].amount
      const history = this.tableData[findIndex].history
        let historyArea = ''
        if(history.length > 0){
            let historyList = ''
            history.map((item) => {
                let status = ''
                if(item.status === '1')
                    status = '<span class="badge badge-success">Onaylandı.</span>'
                else if(item.status === '2')
                    status = '<span class="badge badge-danger">Red Edildi.</span>'
                historyList = historyList +
                    '    <tr>\n' +
                    '      <th><span class="badge badge-secondary">'+item.bank_name+'</span></th>\n' +
                    '      <th><span class="badge badge-secondary">'+this.$options.filters.currency(item.amount)+' TRY</span></th>\n' +
                    '      <th><span class="badge badge-secondary">'+this.$options.filters.formatDate(item.date)+'</span></th>\n' +
                    '      <td>'+status+'</td>\n' +
                    '    </tr>\n'
            })
            historyArea = '<table class="table table-dark">\n' +
                '  <thead>\n' +
                '    <tr>\n' +
                '      <th scope="col">Banka</th>\n' +
                '      <th scope="col">Tutar</th>\n' +
                '      <th scope="col">Tarih</th>\n' +
                '      <th scope="col">Durum</th>\n' +
                '    </tr>\n' +
                '  </thead>\n' +
                '  <tbody>\n' +
                historyList+
                '  </tbody>\n' +
                '</table>\n'
        }
        else
            historyArea = 'Geçmiş yatırımı bulunamadı..'

      this.$swal({
        title: "Yatırım onaylanacaktır, emin misiniz?",
        html: "<code> Bu site API entegrasyonu kullanmaktadır, yatırım tutarı kullanıcı hesabına otomatik aktarılacaktır. </code> <br>" +
            "<br> <label ><i class='fas fa-globe'></i> "+site_name.site_name+"</label>" +
            "<br> <label ><i class='fas fa-user'></i> "+name+"</label>" +
            "<br> <label ><i class='fas fa-money-bill'></i> "+amount+" TL</label>"+
            historyArea,
          icon: 'success',
        input: 'text',
        inputValue: amount,
        inputAttributes: {
          autocapitalize: 'off',
          placeholder: "Yatırım Tutarı",
        },
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: "Gönder",
        cancelButtonText: "Vazgeç"
      }).then((result) => {
        if(result.value){
          depositService.approveDeposit({id: item.id, amount: result.value})
              .then((res) => {
                if(res.state){
                  this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Kaydedildi.', message: ''})
                }else{
                  this.$store.dispatch('getConfirmMessage', {show:true, icon: 'error', title: 'Ops!', message: res.message})
                }
              })

        }
      })
    },
    cancelDeposit(item){

      const findIndex = this.tableData.findIndex(e => e.id === item.id)
      const name = this.tableData[findIndex].name
      const site_name = this.tableData[findIndex].site_detail
      const amount = this.tableData[findIndex].amount
        const history = this.tableData[findIndex].history
        let historyArea = ''
        if(history.length > 0){
            let historyList = ''
            history.map((item) => {
                let status = ''
                if(item.status === '1')
                    status = '<span class="badge badge-success">Onaylandı.</span>'
                else if(item.status === '2')
                    status = '<span class="badge badge-danger">Red Edildi.</span>'
                historyList = historyList +
                    '    <tr>\n' +
                    '      <th><span class="badge badge-secondary">'+item.bank_name+'</span></th>\n' +
                    '      <th><span class="badge badge-secondary">'+this.$options.filters.currency(item.amount)+' TRY</span></th>\n' +
                    '      <th><span class="badge badge-secondary">'+this.$options.filters.formatDate(item.date)+'</span></th>\n' +
                    '      <td>'+status+'</td>\n' +
                    '    </tr>\n'
            })
            historyArea = '<table class="table table-dark">\n' +
                '  <thead>\n' +
                '    <tr>\n' +
                '      <th scope="col">Banka</th>\n' +
                '      <th scope="col">Tutar</th>\n' +
                '      <th scope="col">Tarih</th>\n' +
                '      <th scope="col">Durum</th>\n' +
                '    </tr>\n' +
                '  </thead>\n' +
                '  <tbody>\n' +
                historyList+
                '  </tbody>\n' +
                '</table>\n'
        }
        else
            historyArea = 'Geçmiş yatırımı bulunamadı..'
        this.$swal({
        title: "Yatırımı iptal etmek istediğinize emin misiniz?",
        html: "<label ><i class='fas fa-globe'></i> "+site_name.site_name+"</label>" +
            "<br> <label ><i class='fas fa-user'></i> "+name+"</label>" +
            "<br> <label ><i class='fas fa-money-bill'></i> "+amount+" TL</label>" +
            historyArea+
            "<br>" +
            "<input type='text' class='form-control' id='answer' placeholder='İptal sebebini belirtin' />",
        icon: 'warning',
        input: 'select',
        inputPlaceholder: 'veya hazır seçin',
        inputOptions: this.answerMessages,
        inputAttributes: {
        },
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: "Gönder",
        cancelButtonText: "Vazgeç",
      })
          .then((msg) => {
            if(!msg.dismiss){
              let message = ''
              if(msg.value){
                message = this.answerMessages[msg.value]
              }else{
                message = document.getElementById("answer").value
              }
              depositService.cancelDeposit({id: item.id, message: message})
                  .then((res) => {
                    if(res.state){
                      this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Kaydedildi.', message: ''})
                    }else{
                      this.$store.dispatch('getConfirmMessage', {show:true, icon: 'error', title: 'Ops!', message: res.message})
                    }
                  })
            }
          })
    },
    getSites() {
      depositService.getSites()
          .then((res) => {
            if(res.state){
              this.activatedSites = res.data
              this.get()

            }
          })
    },
      getAdmins() {
          depositService.getAdministrators()
              .then((res) => {
                  if(res.state){
                      res.data.map(user => {
                          this.admins.push({
                              value: user.id,
                              label: user.username
                          })
                      })
                  }
              })

      },
      getBankAccounts() {
          depositService.bankAccounts({status: true})
              .then((res) => {
                  if(res.state){
                      res.data.map(item => {
                          this.bank_accounts.push({
                              value: item.id,
                              label: item.account_name+'['+item.bank_name+']'
                          })
                      })
                  }
              })

      },
    getStatistics() {
      let admin_id = ''
      if(this.admin_id)
        admin_id = this.admin_id.value

      depositService.depositsStatistics({bank_account_id: this.bank_account_id, panel_two: this.panel_two, payment_type: this.payment_type, admin_id: admin_id ,account_name: this.account_name, account_number: this.account_number,  name: this.name, site_id: this.activatedSites ,page: this.currentPage,  id: this.id, startDate: this.startDate, endDate: this.endDate, api_trx: this.api_trx})
          .then((res) => {
            if(res.state){
              this.approvedAmount = res.statistics.approvedAmount
              this.approvedTotal = res.statistics.approvedTotal
              this.mailAmount = res.statistics.mailAmount
              this.mailTotal = res.statistics.mailTotal
              this.manualTotal = res.statistics.manualTotal
              this.manualAmount = res.statistics.manualAmount
              this.getAccountTotal = res.statistics.getAccountTotal
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    getDetail(item) {
      this.getStatistics()
      let itemIndex = this.tableData.findIndex(e => e.id === item.id)
      if(itemIndex > -1){
        this.tableData.splice(itemIndex, 1);
      }
      depositService.depositDetail({bank_account_id: this.bank_account_id, panel_two: this.panel_two, payment_type: this.payment_type, status: this.tabStatus, id: item.id ,account_name: this.account_name, account_number: this.account_number,  name: this.name, site_id: this.activatedSites ,page: this.currentPage, startDate: this.startDate, endDate: this.endDate, api_trx: this.api_trx})
          .then((res) => {
            if(res.state){
              if(res.data.length > 0){
                this.tableData.unshift(res.data[0])
                if(this.tableData.length === 250)
                  this.tableData.unshift(249, 1)
              }
            }
          })

    },
    removeActivatedSite(item){
      let findIndex = this.activatedSites.findIndex(e => e.id === item.id)
      let s = this.activatedSites[findIndex]
      this.sites.push(s)
      this.activatedSites.splice(findIndex, 1)
      this.get()
    },
    addActivatedSite(item){
      let findIndex = this.sites.findIndex(e => e.id === item.id)
      let s = this.sites[findIndex]
      this.activatedSites.push(s)
      this.sites.splice(findIndex, 1)
      this.get()

    },
      excel() {
          let excelData = Object()
          excelData['ID'] = 'id'
          excelData["SITE ADI"] = {
              callback: (value) => {
                  return `${this.$options.filters.formatDate(value.site_detail.site_name)}`;
              }
          }
          excelData["BANKA"] = 'bank_name'
          excelData["ALICI İSİM"] = 'account_name'
          excelData["ALICI İBAN"] = 'account_number'
          excelData["GÖNDEREN PLAYERID"] = 'player_id'
          excelData["GÖNDEREN İSİM"] = 'name'
          excelData["GÖNDEREN BANKA"] = 'deposit_bank'
          excelData["TUTAR"] = 'amount'
          excelData["TARİH"] = {
              callback: (value) => {
                  return `${this.$options.filters.formatDate(value.update_date)}`;
              }
          }
          excelData["DÜZENLEYEN"] = 'editor_detail.username'
          this.excelFields = excelData
      },
  },
  created() {
    this.panelTwoCheck()
      this.getBankAccounts()
  },
  watch: {
      bank_account_id: function () {
          this.get()
      },
    currentPage: function () {
      this.get()
    },
    tabStatus: function () {
      this.get()
    },
    '$store.getters.newData': function() {
      if(this.$store.getters.newData)
      {
        let deposit_id = this.$store.getters.newData.deposit_id
        let page = this.$store.getters.newData.page

        if(page === 'update-deposit'){
          this.getDetail({id: deposit_id})
        }
      }
    },
  }
};
</script>
<style scoped>
.sites-buttons{
  border-radius: 1rem;
  padding-top: .25rem;
  padding-bottom: .25rem;
}
.sites-buttons:focus, .sites-buttons:hover {
  cursor: pointer;
}
.sites-buttons:focus, .sites-buttons:hover {
  background-color: #fa5252;
}
</style>